module.exports = __webpack_public_path__ + "fonts/iconfont.98ab914.woff";